import type { EditConfirmDialogData } from '../confirm.dialog';

export enum DealerCampaignAbortConfirmActions {
    ABORT = 'Abort',
    CANCEL = 'cancel',
}

export enum DealerCampaignSaveConfirmActions {
    CONFIRM = 'Confirm',
    CANCEL = 'cancel',
}

export function dealerCampaignAbortConfirmDialogData(): EditConfirmDialogData {
    return {
        headline: 'Bestätigen',
        copy: 'Möchten Sie wirklich schließen? Inhalte die nicht gespeichert wurden, gehen verloren.',
        buttons: [
            {
                identifier: DealerCampaignAbortConfirmActions.ABORT,
                label: 'Bestätigen',
            },
            {
                identifier: DealerCampaignAbortConfirmActions.CANCEL,
                label: 'Abbrechen',
            },
        ],
    };
}

export function dealerCampaignSaveConfirmDialogData(): EditConfirmDialogData {
    return {
        headline: 'Bestätigen',
        copy: 'Möchten Sie die Aktion abschließen? Wählen Sie Bestätigen, um die Aktion zu speichern und abzuschließen, oder Abbrechen, um zur Bearbeitung zurückzukehren.',
        info: '​Hinweis: Wenn die Aktion gespeichert wird und das Aktionsdatum auf den heutigen Tag fällt, erscheint sie auf der Startseite.',
        buttons: [
            {
                identifier: DealerCampaignSaveConfirmActions.CONFIRM,
                label: 'Bestätigen',
            },
            {
                identifier: DealerCampaignSaveConfirmActions.CANCEL,
                label: 'Abbrechen',
            },
        ],
    };
}
